import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap5';

import Modal from 'components/new_ui/Modal/Modal';

export default function ChooseEditPaymentMethodMode({
  show, onEditInformation, onPaymentMethod, onDeletePaymentMethod, isPossibleDeletePaymentMethod, onHide,
}) {
  return (
    <Modal size="lg" show={show}>
      <>
        <div className="text-center">
          <h2>Edit Payment Method</h2>
          <small>Secure & Swift: Link Your Payment Method in Just a Few Clicks!</small>
        </div>
        <Row className="mt-3">
          <Col md={6} className="mt-2">
            Link a credit card or bank account to your
            profile to setup automatic payment.
          </Col>
          <Col md={6} className="text-center text-md-end mt-2">
            <Button
              style={{ width: '300px' }}
              onClick={() => {
                onHide();
                onPaymentMethod();
              }}
            >
              Update Payment Information
            </Button>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={6} className="mt-2">
            Enter an actual billing address to receive invoice
            emails and pay manually.
          </Col>
          <Col md={6} className="text-center text-md-end mt-2">
            <Button
              style={{ width: '300px' }}
              onClick={() => {
                onHide(); onEditInformation();
              }}
            >
              Update Billing Address
            </Button>
          </Col>
        </Row>
        {isPossibleDeletePaymentMethod && (
          <Row className="mt-3">
            <Col md={6} className="mt-2">
              Permanently disconnect your payment option. Future invoices will be sent to your email.
            </Col>
            <Col md={6} className="text-center text-md-end mt-2">
              <Button
                variant="danger"
                style={{ width: '300px' }}
                onClick={() => {
                  onHide(); onDeletePaymentMethod();
                }}
              >
                Remove Payment Method
              </Button>
            </Col>

          </Row>
        )}
        <Row className="mt-5">
          <Col className="text-center text-md-end">
            <Button
              variant="outline-primary"
              className=""
              onClick={onHide}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </>
    </Modal>
  );
}

ChooseEditPaymentMethodMode.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onEditInformation: PropTypes.func.isRequired,
  onPaymentMethod: PropTypes.func.isRequired,
  onDeletePaymentMethod: PropTypes.func.isRequired,
  isPossibleDeletePaymentMethod: PropTypes.bool.isRequired,
};
